import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  planName: yup.string().required(),
  payg: yup.boolean().required(),
});

export function useChangePlanMutation({ onError, onSuccess, onSettled } = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto) => {
      const req = requestSchema.validateSync(dto, {
        strict: true,
      });

      return http.post(HTTP_ENDPOINTS.chartSmart.changeSubscriptionPlan(), {
        plan_name: req.planName,
        payg: Number(req.payg),
      });
    },
    onSuccess: () => {
      onSuccess?.();
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.subscriptionDetail],
      });
    },
    onError: (...args) => {
      onError?.(...args);
    },
    onSettled: () => {
      onSettled?.();
    },
  });
}
